import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { reviewAssignedBijlageForEntity } from '../services/reviewAssignedBijlageForEntity'

import { queryKey as queryKeyAssignedBijlagen } from './useAssignedBijlagenForEntity'

export { useReviewAssignedBijlageForEntity }

const useReviewAssignedBijlageForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: reviewAssignedBijlageForEntity,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [queryKeyAssignedBijlagen] })
      successAlert(
        `Bijlage succesvol ${variables.approved ? 'goedgekeurd' : 'afgekeurd'}`,
      )
    },
  })
}
